<div class="starly-toast-container" *ngIf="toast">
  <div class="starly-toast" [ngClass]="toast.status">
    <div class="banner-icon">
      <ion-spinner name="dots" *ngIf="toast.status === 'pending'"></ion-spinner>
      <ion-icon *ngIf="toast.status !== 'pending'" [name]="toast.icon"></ion-icon>
    </div>
    <div class="banner-body">
      <p class="banner-label">{{ toast.title }}</p>
      <p class="banner-message">{{ toast.description }}</p>
    </div>
    <div class="banner-avatar">
      <img src="assets/logos/starly-avatar.png" alt="Starly avatar" />
    </div>
  </div>
</div>